import * as React from "react";
import cx from "classnames";
import { StickyContainer } from "react-sticky";

import Footer from "./Footer";
import Nav from "./NavContainer";
import "./Layout.css";

export interface MainLayoutProps {
  className?: string;
  id?: string;
  separateChildren?: boolean;
  children: React.ReactChild | React.ReactChild[];
}

const getChildrenProps = ({ separateChildren }: MainLayoutProps) =>
  separateChildren
    ? { fullWidth: false, hasShadow: true }
    : { fullWidth: true, hasShadow: false };

const MainLayout = (props: MainLayoutProps) => (
  <div id={props.id} className={cx(props.className, "main-layout")}>
    <StickyContainer>
      <header>
        <Nav {...getChildrenProps(props)} />
      </header>
      <main>{props.children}</main>
      <footer>
        <Footer {...getChildrenProps(props)} />
      </footer>
    </StickyContainer>
  </div>
);

export default MainLayout;



// WEBPACK FOOTER //
// ./src/layouts/Main/Layout.tsx